export default __webpack_public_path__ + "static/media/number1.1db30414.webp";